import { useMsal } from "@azure/msal-react";
import { Button, LargeTitle, makeStyles } from "@fluentui/react-components";
import { t } from "../i18n/i18n";
const useStyles = makeStyles({
  wrapper: {
    position: "absolute",
    top: "30%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    justifyContent: "center",
  },
});

export const Login = () => {
  const classes = useStyles();
  const { instance } = useMsal();

  const initializeSignIn = () => {
    instance.loginRedirect();
  };
  return (
    <article>
      <div className={classes.wrapper}>
        <LargeTitle as="h2">{t("WelcomeTitle")}</LargeTitle>
        <div>
          <Button size="large" appearance="primary" onClick={initializeSignIn}>
            {t("SignIn")}
          </Button>
        </div>
      </div>
    </article>
  );
};
